import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import { getMouseCoordinate, pluckNumber, pluck, hasSVG } from '../../../fc-core/src/lib';
import { ComponentInterface } from '../../../fc-core/src/component-interface';

var UNDEF,
    DEFAULTCOLOR = '#EEEEEE',
    DEFAULTALPHA = 50,
    crispFixer = hasSVG ? 0 : .5,
    crisping = function crisping(a, b) {
  return Math.round(a + (b % 2 / 2 + crispFixer)) - (b % 2 / 2 + crispFixer);
},
    handlers = function handlers(a) {
  return {
    onhover: function onhover(b, c) {
      a.show(c.axes ? {
        axesInfo: c.axes
      } : {
        event: b
      });
    },
    onhoverout: function onhoverout(b) {
      a.hide({
        event: b
      });
    }
  };
},
    createRaphaelGroup = function createRaphaelGroup(a, b, c) {
  var d = c.getFromEnv('animationManager');
  return d.setAnimation({
    el: 'group',
    attr: {
      name: a
    },
    container: b,
    state: 'appearing',
    component: c,
    label: 'group'
  });
};

var CrossLineManagerBand =
/*#__PURE__*/
function (_ComponentInterface) {
  _inherits(CrossLineManagerBand, _ComponentInterface);

  function CrossLineManagerBand() {
    var _this;

    _classCallCheck(this, CrossLineManagerBand);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CrossLineManagerBand).call(this)), _this._handlerAPI = handlers(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(CrossLineManagerBand, [{
    key: "getAttachedAxisInfo",
    value: function getAttachedAxisInfo() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b,
          c,
          d,
          e,
          f = this,
          g = f.getLinkedParent(),
          h = g.getAxes(),
          j = a.originalEvent && getMouseCoordinate(f.getFromEnv('chart-container'), a.originalEvent, f.getFromEnv('chart')),
          k = j && j.chartX || 0,
          l = j && j.chartY || 0;

      for (b = h.length - 1; 0 <= b; b--) {
        if (c = h[b].axis, d = h[b].isY, !d) return e = !!c.config.isVertical, {
          value: e ? c.getValue(l) : c.getValue(k),
          axis: c,
          isVertical: e,
          isY: !1
        };
      }
    }
  }, {
    key: "configure",
    value: function configure() {
      var a = this,
          b = a.config,
          c = a.getFromEnv('chartConfig'),
          d = a.getFromEnv('chart-attrib'),
          e = pluck(d.crosslinecolor, c.crosslinecolor, DEFAULTCOLOR),
          f = pluckNumber(c.defaultcrosslinethickness),
          g = pluckNumber(d.crosslineanimation, 0),
          h = g && 1e3 * pluckNumber(d.crosslineanimationduration, .09),
          i = pluckNumber(d.drawcrosslineontop, c.drawcrosslineontop, 0),
          j = pluckNumber(d.crosslinealpha, c.crosslinealpha, DEFAULTALPHA);
      b.drawCrossLine = pluckNumber(d.drawcrossline, c.drawcrossline, 0), b.bandStyle = {
        fillcolor: e,
        alpha: j,
        thickness: f,
        managerId: a.getId(),
        onTop: i,
        cursor: 'pointer',
        animDuration: h
      };
    }
  }, {
    key: "createGroup",
    value: function createGroup() {
      var a = this,
          b = a.getLinkedParent().getChildContainer('crosslineBottom'),
          c = a.getLinkedParent().getChildContainer('crosslineTop');
      a.getChildContainer('crosslineTop') || a.addChildContainer('crosslineTop', createRaphaelGroup('crosslineTop', c, a)), a.getChildContainer('crosslineBottom') || a.addChildContainer('crosslineBottom', createRaphaelGroup('crosslineBottom', b, a));
    }
  }, {
    key: "show",
    value: function show() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b = this,
          c = a.event,
          d = b.config;
      d.attachedCanvasAxisInfo = b.getAttachedAxisInfo(c), b._setAptAxesInfo(a.axesInfo, a.value), b._show(c);
    }
  }, {
    key: "_setAptAxesInfo",
    value: function _setAptAxesInfo() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var b = arguments.length > 1 ? arguments[1] : undefined;
      var c,
          d,
          e = this,
          f = a.length,
          g = e.config.attachedCanvasAxisInfo;
      if (a.length) for (d = 0; d < f; d++) {
        if (c = a[d], c.axis === g.axis) {
          g.value = c.value;
          break;
        }
      }
      b !== UNDEF && (g.value = b);
    }
  }, {
    key: "_show",
    value: function _show(a) {
      var b,
          c,
          d,
          e,
          f = this,
          g = f.config,
          h = f.getFromEnv('chartConfig'),
          i = f.getChildren('crossline')[0],
          j = g.attachedCanvasAxisInfo,
          k = j.value,
          l = j.axis,
          m = j.isVertical,
          n = l.config.endPad,
          o = l.getVisibleConfig().maxValue - n,
          p = Math.round(k),
          q = j.axis.getPixel(p),
          r = Object.assign({}, g.bandStyle),
          s = f.getFromEnv('canvasConfig'),
          t = s.canvasTop,
          u = s.canvasLeft,
          v = s.canvasWidth,
          w = s.canvasHeight,
          x = g.drawCrossLine;
      0 > p || p > o || f.config.lastIndex !== p && x && ((d = r.thickness) === UNDEF && (!1 === h._hascolumn ? d = 1 : (b = l.getPixel(0), c = l.getPixel(1), d = Math.abs(c - b))), e = crisping(q, d), f.createGroup(), r.thickness = d, r = m ? Object.assign(r, {
        x1: u,
        y1: e,
        x2: u + v,
        y2: e
      }) : Object.assign(r, {
        x1: e,
        y1: t,
        x2: e,
        y2: t + w
      }), i.show(r), f.getFromEnv('chart').fireChartInstanceEvent('onChangeCrossLine', {
        currentIndex: p,
        lastIndex: f.config.lastIndex,
        source: a ? 'mouse interaction' : 'public API'
      }), f.config.lastIndex = p);
    }
  }, {
    key: "hide",
    value: function hide() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b = this,
          c = b.getLinkedParent(),
          d = a.event,
          e = d && d.originalEvent && getMouseCoordinate(c.getFromEnv('chart-container'), d && d.originalEvent, c.getFromEnv('chart')),
          f = e && e.chartX || 0,
          g = e && e.chartY || 0;
      c.isWithinCanvas(f, g) || (b.getFromEnv('chart').fireChartInstanceEvent('onChangeCrossLine', {
        lastIndex: b.config.lastIndex,
        source: d ? 'mouse interaction' : 'public API'
      }), delete this.config.lastIndex, this.getChildren('crossline')[0].hide());
    }
  }, {
    key: "getType",
    value: function getType() {
      return 'crossline-manager';
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'crossline-manager-band-category-axis';
    }
  }]);

  return CrossLineManagerBand;
}(ComponentInterface);

export default CrossLineManagerBand;